module.exports = __webpack_public_path__ + "static/media/upcomingEvents_3.86e46ee4.jpg";